import { Provider, Type } from '@angular/core';
import { DatasourceTableService } from '../api/datasource-table.service';
import {
  DatasourceGitService,
  DatasourceJobSettingsValidationService,
  DatasourceQuery,
  DatasourceState,
  DatasourceStore,
  DatasourceTableJobQuery,
  DatasourceTableJobStore,
  DatasourceTableQuery,
  DatasourceTableStore,
} from '../state';
import { DatasourceService } from './datasource.service';

export interface DatasourceServiceDef {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  DatasourceService: Type<DatasourceService<DatasourceState<any>>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  DatasourceStore: Type<DatasourceStore<DatasourceState<any>>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  DatasourceQuery: Type<DatasourceQuery<DatasourceState<any>>>;
  DatasourceTableService: Type<DatasourceTableService>;
  DatasourceTableStore: Type<DatasourceTableStore>;
  DatasourceTableQuery: Type<DatasourceTableQuery>;
  DatasourceTableJobStore: Type<DatasourceTableJobStore>;
  DatasourceTableJobQuery: Type<DatasourceTableJobQuery>;
  DatasourceGitService: Type<DatasourceGitService>;
  DatasourceJobSettingsValidationService: Type<DatasourceJobSettingsValidationService>;
}

export function provideDatasource(providers: DatasourceServiceDef): Provider[] {
  const {
    DatasourceService: service,
    DatasourceStore: store,
    DatasourceQuery: query,
    DatasourceTableService: tableService,
    DatasourceTableStore: tableStore,
    DatasourceTableQuery: tableQuery,
    DatasourceTableJobStore: tableJobStore,
    DatasourceTableJobQuery: tableJobQuery,
    DatasourceGitService: gitService,
    DatasourceJobSettingsValidationService: jobSettingsValidation,
  } = providers;
  return [
    {
      provide: DatasourceService,
      useExisting: service,
    },
    {
      provide: DatasourceStore,
      useExisting: store,
    },
    {
      provide: DatasourceQuery,
      useExisting: query,
    },
    {
      provide: DatasourceTableService,
      useExisting: tableService,
    },
    {
      provide: DatasourceTableStore,
      useExisting: tableStore,
    },
    {
      provide: DatasourceTableQuery,
      useExisting: tableQuery,
    },
    {
      provide: DatasourceTableJobStore,
      useExisting: tableJobStore,
    },
    {
      provide: DatasourceTableJobQuery,
      useExisting: tableJobQuery,
    },
    {
      provide: DatasourceGitService,
      useExisting: gitService,
    },
    {
      provide: DatasourceJobSettingsValidationService,
      useExisting: jobSettingsValidation,
    },
  ];
}
